import DocShell, { Clause } from '@/components/rack/DocShell';

/**
 * 服务条款。
 *
 * 旧版是模板：主语「我们」、旧品牌、通用免责。这版按阳仔AI接活的实际情况重写，
 * 并把量化那条边界写进条款——首页和案例页都声明了「不代客理财、不承诺收益」，
 * 法务页不写，声明就只是文案。
 */
export default function TermsOfService() {
  return (
    <DocShell
      code="TERMS"
      title="服务条款"
      updated="2026-09-01"
      thesis="站上是说明，合同才是承诺"
      lede="这份条款只管你访问 minddock.ai 这个站。真正的项目怎么做、交什么、多少钱、拿什么验收，都写在合同和书面方案里——站上的任何一句话都不替代那份文件。"
      description="阳仔AI（minddock.ai）服务条款：站点内容不构成项目承诺，项目以合同与书面方案为准；量化方向不代客理财、不承诺收益、不提供投资建议。"
      path="/terms"
    >
      <div className="mt-4 border-t border-rack-bone/12">
        <Clause no="§01" title="这份条款管什么">
          <p>
            管的是你访问和使用 minddock.ai 这个站。具体合作以双方签署的合同或我出具的书面方案、
            报价单为准；条款与合同冲突时，以合同为准。
          </p>
        </Clause>

        <Clause no="§02" title="站上的内容怎么理解">
          <p>
            案例页写的是能交付什么形态、能进哪些业务领域、做过什么。项目状态（线上可访问 /
            内测中 / 在建 / 提审中）按发布当时的实际情况标注，不保证一直如此。
          </p>
          <p>
            这些内容说明能力范围，不构成对你项目的承诺。报价、工期、验收标准只在书面方案里给。
          </p>
        </Clause>

        <Clause no="§03" title="怎么用站上的东西">
          <p>正常浏览、引用、转发链接都没问题，注明来源即可。</p>
          <p>
            不要批量爬取整站内容再包装成自己的作品集，也不要使用站上的名称、头像、文案冒充我本人
            或我提供的服务。
          </p>
        </Clause>

        <Clause no="§04" title="知识产权">
          <p>站上的文字、图形、代码与设计归我所有。</p>
          <p>
            客户项目的交付物按合同约定归属：默认把项目源码交付给客户，我保留通用工具、
            底层库和方法本身的权利，以便继续用在其它项目上。
          </p>
        </Clause>

        <Clause no="§05" title="量化方向的边界">
          <p className="text-rack-bone/75">
            量化只做工程交付：策略实现、回测框架、风控、执行链路与监控。
            <span className="text-rack-ember">
              不代客理财、不承诺收益、不提供投资建议，也不接受资金托管。
            </span>
          </p>
          <p>
            站上出现的任何净值、回撤、收益类图形都是示意数据，用于说明系统做了什么，
            不构成投资建议，也不代表任何真实账户的表现。
          </p>
        </Clause>

        <Clause no="§06" title="免责">
          <p>
            站点按现状提供，不保证不间断、无错误或永远可访问。站外链接由对方运营，
            其内容与可用性不由我控制。
          </p>
          <p>
            因使用站上信息导致的间接或后果性损失，我不承担责任。具体项目中的责任范围，
            在合同里写明。
          </p>
        </Clause>

        <Clause no="§07" title="变更">
          <p>
            条款可能调整，调整后更新顶部日期。继续使用本站，视为接受当前版本；
            已签署的合同不受这一页变更的影响。
          </p>
        </Clause>

        <Clause no="§08" title="适用法律">
          <p>
            适用中华人民共和国法律。有争议先直接谈；谈不拢的，按合同约定的争议解决方式处理。
          </p>
        </Clause>
      </div>
    </DocShell>
  );
}
